var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: false, "label-position": "top", size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.Barcode") } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.max2000Line"),
                          rows: 5,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.queryForm.params.waybillNumbers,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm.params,
                              "waybillNumbers",
                              $$v
                            )
                          },
                          expression: "queryForm.params.waybillNumbers",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("fixDutyFine.DefiniteTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: false,
                          "default-time": ["00:00:00", "23:59:59"],
                          format:
                            _vm.$i18n.locale == "zh" ? _vm.zhDate : _vm.ptDate,
                          placeholder: _vm.$t("newOrder.SelectDatetime"),
                          "range-separator": "~",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("placeOrder.area") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.regions,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "regions", $$v)
                            },
                            expression: "queryForm.params.regions",
                          },
                        },
                        _vm._l(_vm.areaList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("fixDutyFine.ResponsibleLink") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.processes,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "processes", $$v)
                            },
                            expression: "queryForm.params.processes",
                          },
                        },
                        _vm._l(_vm.linkResponsibility, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "28px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-search",
                          size: "small",
                          type: "primary",
                        },
                        on: { click: _vm.enterSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-refresh-left",
                          size: "small",
                          type: "info",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resetForm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.totalData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("placeOrder.area"),
              align: "center",
              prop: "region",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.Total"),
              align: "center",
              prop: "totalCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#00A551", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.toSearch(scope.row, null)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.totalCount) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.frontEndCollection"),
              align: "center",
              prop: "frontPickupCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#00A551", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.toSearch(scope.row, "FRONT_PICKUP")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.frontPickupCount) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.hubOperation"),
              align: "center",
              prop: "hubOperationCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#00A551", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.toSearch(scope.row, "HUB_OPERATION")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.hubOperationCount) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.collectionTransport"),
              align: "center",
              prop: "pickupTransportCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#00A551", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.toSearch(scope.row, "PICKUP_TRANSPORT")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(scope.row.pickupTransportCount) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.glpUnloading"),
              align: "center",
              prop: "glpUnloadCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#00A551", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.toSearch(scope.row, "GLP_UNLOAD")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.glpUnloadCount) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flx-between", staticStyle: { margin: "10px 0" } },
        [
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.$t("navbar.gong")))]),
            _c("span", { staticStyle: { margin: "0 5px", color: "#00A551" } }, [
              _vm._v(_vm._s(_vm.queryForm.total)),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("fixDutyFine.Item")))]),
          ]),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.allExportOrder },
            },
            [_vm._v(_vm._s(_vm.$t("navbar.export")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                align: item.center,
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              scope.row[item.prop]
                                ? "" + scope.row[item.prop]
                                : "- -"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }